const LANDING_SECTIONS = [
  {
    title: 'Ignite your potential',
    description: '<div>Learn the fundamentals of launching a digital content business and discover the most effective ways to generate revenue.<div>',
    textColor: '#03153B',
    backgroundColor: '#F1F2ED',
    image: {
      src: require('@/assets/images/landings/ignite-potential.webp'),
      isFirst: true,
      isSmall: true,
    },
    buttonTextColor: '#F1F2ED',
    hasSlot: true,
    pageToRedirect: 'HowToMakeMoneyOnlineCourse',
    to: 'Homepage',
  },
  {
    title: 'Build your business on Tryb',
    description: '<div>Take what you’ve learnt and put it into practice! Tryb provides all the tools you need to launch and grow a sustainable content business in one place.<div>',
    textColor: '#FFFFFF',
    backgroundColor: '#03153B',
    image: {
      src: require('@/assets/images/homepage/sell.webp'),
    },
    buttonTextColor: '#03153B',
    to: 'Homepage',
  },
];
const COURSE_LANDING_SECTIONS = [
  {
    title: 'Build your business on Tryb',
    description: '<div>Take what you’ve learnt and put it into practice! Tryb provides all the tools you need to launch and grow a sustainable content business in one place.<div>',
    textColor: '#FFFFFF',
    backgroundColor: '#03153B',
    image: {
      src: require('@/assets/images/homepage/sell.webp'),
    },
    buttonTextColor: '#03153B',
    to: 'Homepage',
  },
];

const DEFAULT_PROMOTION_LANDING_ITEM = {
  isLargeTitle: true,
  hasSlot: true,
  to: 'Homepage',
};

const PROMOTION_LANDINGS = {
  'how-to-make-money-online': [
    {
      ...DEFAULT_PROMOTION_LANDING_ITEM,
      title: 'Learn how to monetize your content online',
      description: 'Get access to our <span>free mini-course</span>',
      textColor: '#420E64',
      backgroundColor: '#DAD3FF',
      image: {
        srcDesktop: require('@/assets/images/landings/how-make-money-desktop.webp'),
        srcMobile: require('@/assets/images/landings/how-make-money-mobile.webp'),
        isFullscreen: true,
      },
      buttonTextColor: '#DAD3FF',
      pageToRedirect: 'HowToMakeMoneyOnlineCourse',
    },
    ...LANDING_SECTIONS,
  ],
  'overcoming-starter-block': [
    {
      ...DEFAULT_PROMOTION_LANDING_ITEM,
      title: 'Overcoming starter block',
      description: 'Get access to our <span>free mini-course</span>',
      textColor: '#76131B',
      backgroundColor: '#DFBED8',
      image: {
        srcDesktop: require('@/assets/images/landings/overcoming-starter-desktop.webp'),
        srcMobile: require('@/assets/images/landings/overcoming-starter-mobile.webp'),
        isFullscreen: true,
      },
      buttonTextColor: '#DFBED8',
      pageToRedirect: 'OvercomingStarterBlockOnlineCourse',
    },
    ...LANDING_SECTIONS,
  ],
  'trackling-imposter-syndrome': [
    {
      ...DEFAULT_PROMOTION_LANDING_ITEM,
      title: 'How to tackle imposter syndrome',
      description: 'Get access to our <span>free mini-course</span>',
      textColor: '#001239',
      backgroundColor: '#82C0E4',
      image: {
        srcDesktop: require('@/assets/images/landings/imposter-syndrome-desktop.webp'),
        srcMobile: require('@/assets/images/landings/imposter-syndrome-mobile.webp'),
        isFullscreen: true,
      },
      buttonTextColor: '#82C0E4',
      pageToRedirect: 'TracklingImposterSyndromeOnlineCourse',
    },
    ...LANDING_SECTIONS,
  ],
  'start-thinking-like-an-entrepreneur': [
    {
      ...DEFAULT_PROMOTION_LANDING_ITEM,
      title: 'Level up your career as a creator',
      description: 'Get access to our <span>free mini-course</span>',
      textColor: '#01321F',
      backgroundColor: '#D4FDA1',
      image: {
        srcDesktop: require('@/assets/images/landings/thinking-like-entrepeuner-desktop.webp'),
        srcMobile: require('@/assets/images/landings/thinking-like-entrepeuner-mobile.webp'),
        isFullscreen: true,
      },
      buttonTextColor: '#D4FDA1',
      pageToRedirect: 'startThinkingLikeAnEntrepreneurOnlineCourse',
    },
    ...LANDING_SECTIONS,
  ],
  '100-true-fans': [
    {
      ...DEFAULT_PROMOTION_LANDING_ITEM,
      title: 'Understand why only takes 100 fans to thrive your influencer career',
      description: 'Get access to our <span>free mini-course</span>',
      textColor: '#420E64',
      backgroundColor: '#CBC1FE',
      image: {
        srcDesktop: require('@/assets/images/landings/how-make-money-desktop.webp'),
        srcMobile: require('@/assets/images/landings/how-make-money-mobile.webp'),
        isFullscreen: true,
      },
      buttonTextColor: '#CBC1FE',
      pageToRedirect: '100TrueFansOnlineCourse',
    },
    ...LANDING_SECTIONS,
  ],
  'how-to-make-money-online-content-creator': [
    {
      ...DEFAULT_PROMOTION_LANDING_ITEM,
      title: 'Learn how to monetize your content online',
      description: 'Get access to our <span>free mini-course</span>',
      textColor: '#FFFFFF',
      backgroundColor: '#570C59',
      image: {
        srcDesktop: require('@/assets/images/landings/how-make-money-desktop.webp'),
        srcMobile: require('@/assets/images/landings/how-make-money-mobile.webp'),
        isFullscreen: true,
      },
      buttonTextColor: '#570C59',
      pageToRedirect: 'HowToMakeMoneyOnlineCourse',
      hasLabel: true,
      video: {
        src: 'https://firebasestorage.googleapis.com/v0/b/foodtryb.appspot.com/o/assets%2Fcourse-promotion-intro.mp4?alt=media&token=e15e89f9-e627-442e-ac8d-743b6518ff51',
      },
    },
    ...LANDING_SECTIONS,
  ],
  'overcoming-starter-block-content-creator': [
    {
      ...DEFAULT_PROMOTION_LANDING_ITEM,
      title: 'Overcoming starter block',
      description: 'Get access to our <span>free mini-course</span>',
      textColor: '#FFFFFF',
      backgroundColor: '#570C59',
      image: {
        srcDesktop: require('@/assets/images/landings/how-make-money-desktop.webp'),
        srcMobile: require('@/assets/images/landings/how-make-money-mobile.webp'),
      },
      buttonTextColor: '#570C59',
      pageToRedirect: 'OvercomingStarterBlockOnlineCourse',
      hasLabel: true,
      video: {
        src: 'https://firebasestorage.googleapis.com/v0/b/foodtryb.appspot.com/o/assets%2Fcourse-promotion-intro.mp4?alt=media&token=e15e89f9-e627-442e-ac8d-743b6518ff51',
      },
    },
    ...LANDING_SECTIONS,
  ],
  'trackling-imposter-syndrome-content-creator': [
    {
      ...DEFAULT_PROMOTION_LANDING_ITEM,
      title: 'How to tackle imposter syndrome',
      description: 'Get access to our <span>free mini-course</span>',
      textColor: '#FFFFFF',
      backgroundColor: '#570C59',
      image: {
        srcDesktop: require('@/assets/images/landings/how-make-money-desktop.webp'),
        srcMobile: require('@/assets/images/landings/how-make-money-mobile.webp'),
      },
      buttonTextColor: '#570C59',
      pageToRedirect: 'TracklingImposterSyndromeOnlineCourse',
      hasLabel: true,
      video: {
        src: 'https://firebasestorage.googleapis.com/v0/b/foodtryb.appspot.com/o/assets%2Fcourse-promotion-intro.mp4?alt=media&token=e15e89f9-e627-442e-ac8d-743b6518ff51',
      },
    },
    ...LANDING_SECTIONS,
  ],
  'start-thinking-like-an-entrepreneur-content-creator': [
    {
      ...DEFAULT_PROMOTION_LANDING_ITEM,
      title: 'Level up your career as a creator',
      description: 'Get access to our <span>free mini-course</span>',
      textColor: '#FFFFFF',
      backgroundColor: '#570C59',
      image: {
        srcDesktop: require('@/assets/images/landings/how-make-money-desktop.webp'),
        srcMobile: require('@/assets/images/landings/how-make-money-mobile.webp'),
      },
      buttonTextColor: '#570C59',
      pageToRedirect: 'startThinkingLikeAnEntrepreneurOnlineCourse',
      hasLabel: true,
      video: {
        src: 'https://firebasestorage.googleapis.com/v0/b/foodtryb.appspot.com/o/assets%2Fcourse-promotion-intro.mp4?alt=media&token=e15e89f9-e627-442e-ac8d-743b6518ff51',
      },
    },
    ...LANDING_SECTIONS,
  ],
  '100-true-fans-content-creator': [
    {
      ...DEFAULT_PROMOTION_LANDING_ITEM,
      title: 'Why it only takes 100 true fans to make a living',
      description: 'Get access to our <span>free mini-course</span>',
      textColor: '#FFFFFF',
      backgroundColor: '#570C59',
      image: {
        srcDesktop: require('@/assets/images/landings/how-make-money-desktop.webp'),
        srcMobile: require('@/assets/images/landings/how-make-money-mobile.webp'),
      },
      buttonTextColor: '#570C59',
      pageToRedirect: '100TrueFansOnlineCourse',
      hasLabel: true,
      video: {
        src: 'https://firebasestorage.googleapis.com/v0/b/foodtryb.appspot.com/o/assets%2Fcourse-promotion-intro.mp4?alt=media&token=e15e89f9-e627-442e-ac8d-743b6518ff51',
      },
    },
    ...LANDING_SECTIONS,
  ],
};

const DEFAULT_COURSE_LANDING_ITEM = {
  title: 'You’ve unlocked our free mini-course!',
  description: 'Work your way through all of the videos below to learn the fundamentals of launching a digital content business online.',
  backgroundColor: '#F1F2ED',
  sections: COURSE_LANDING_SECTIONS,
};

const PROMOTION_COURSE_LANDINGS = {
  'how-to-make-money-online-course': {
    ...DEFAULT_COURSE_LANDING_ITEM,
    videoTitle: 'How to make money online',
    videoDescription: 'We look at the various ways someone can make money from their online content and audience.',
    mainVideoId: 'SZbATrHvOfn1FCFapI9W',
  },
  'overcoming-starter-block-online-course': {
    ...DEFAULT_COURSE_LANDING_ITEM,
    videoTitle: 'Overcoming Starter Block',
    videoDescription: 'Just getting started can the biggest hurdle for most creators. Explore how to let your fears launch you forward.',
    mainVideoId: 'pj65VAsHPOn7tVabcUjT',
  },
  'trackling-imposter-syndrome-online-course': {
    ...DEFAULT_COURSE_LANDING_ITEM,
    videoTitle: 'How to tackle imposter syndrome',
    videoDescription: 'Learn how to use a growth mindset to overcome imposter syndrome, so you can get on your way to continue creating your digital content business.',
    mainVideoId: 'S0ervY5pBPQe9moABU2m',
  },
  'start-thinking-like-an-entrepreneur-online-course': {
    ...DEFAULT_COURSE_LANDING_ITEM,
    videoTitle: 'Start thinking like an entrepreneur',
    videoDescription: 'Learn how to start thinking like a mini media business. Independent creators hold the power nowadays, so it\'s right that they build a sustainable business around their content.',
    mainVideoId: 'uBNWDrGz7S8y8O5hlctJ',
  },
  '100-true-fans-online-course': {
    ...DEFAULT_COURSE_LANDING_ITEM,
    videoTitle: '100 True Fans',
    videoDescription: 'We discuss the principle that you don\'t actually need a large audience to earn money from your content. You just need your true fans.',
    mainVideoId: 'kiaSwasX7lOLQMi683Wp',
  },
};

export {
  PROMOTION_LANDINGS,
  PROMOTION_COURSE_LANDINGS,
};
